import { compareValues } from "@sscs/utils";
import { getCvssSeverity } from "../../../utils";
export function isTriagedVulnerability(vulnerability) {
    return vulnerability.outcome !== undefined;
}
export const getMostRecentResolution = (vulnerability) => {
    return vulnerability.bugs.reduce((current, mostRecentResolution) => mostRecentResolution.resolved.timestamp > current.resolved.timestamp
        ? mostRecentResolution
        : current);
};
export const initFilter = {
    cve: null,
    exploit: [],
    hideTriaged: true,
    cvss_score_severity: "ALL",
};
export const initSort = {
    property: "cvss_score",
    reverse: true,
};
const compareBugInfo = (first, second, reverse) => compareValues(first.timestamp ? first.timestamp : first.version, second.timestamp ? second.timestamp : second.version, reverse);
export const specialCasesForSorting = {
    cvss_score: (first, second, reverse) => compareValues(first.cvss.base_score, second.cvss.base_score, reverse),
    introduced: (first, second, reverse) => {
        const firstBug = getMostRecentResolution(first);
        const secondBug = getMostRecentResolution(second);
        return compareBugInfo(firstBug.introduced, secondBug.introduced, reverse);
    },
    resolved: (first, second, reverse) => {
        const firstBug = getMostRecentResolution(first);
        const secondBug = getMostRecentResolution(second);
        return compareBugInfo(firstBug.resolved, secondBug.resolved, reverse);
    },
};
export const filterVulnerabilities = (vulnerabilities, filter) => {
    const hasCveFilter = filter.cve !== initFilter.cve;
    const hasExploitFilter = filter.exploit.length > 0;
    const hasSeverityFilter = filter.cvss_score_severity !== initFilter.cvss_score_severity;
    if (!hasCveFilter &&
        !hasExploitFilter &&
        !filter.hideTriaged &&
        !hasSeverityFilter)
        return vulnerabilities;
    return vulnerabilities.filter((vulnerability) => {
        if (hasCveFilter && vulnerability.cve !== filter.cve)
            return false;
        if (filter.hideTriaged && isTriagedVulnerability(vulnerability))
            return false;
        if (hasExploitFilter &&
            !filter.exploit.every((tag) => vulnerability.exploit.includes(tag)))
            return false;
        if (hasSeverityFilter &&
            getCvssSeverity(vulnerability.cvss.base_score) !==
                filter.cvss_score_severity) {
            return false;
        }
        return true;
    });
};
//# sourceMappingURL=utils.js.map